import {
  Component,
  ElementRef,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CupService } from '../../shared/services/cup.service';
import { UrlconstantsService } from '../../shared/services/urlconstants.service';
import { ProviderportalService } from '../providerportal.service';
import { IProviderSiteSearch } from '../providersearch_model/providerdetails';
//import { Observable } from "rxjs/Observable";
//import 'rxjs/add/observable/throw';
// import { Angular2Csv } from 'angular2-csv'
import { ngxCsv } from 'ngx-csv';
import * as XLSX from 'xlsx-js-style';
import { saveAs } from 'file-saver';
import * as _ from 'lodash';
import { MenuItem } from 'primeng/api';
import { Observable, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { urls } from '../../common/model/properties';
import { customDateFilerPipe } from '../../customDateFilter';
import { MemberFilterArrayPipe } from '../../filterArray';
import { MemberSearchFilterPipe } from '../../member-search-filter.pipe';
import { SecureStorageService } from '../../secure-storage.service';
import { CupDateService } from '../../shared/services/cup-date.service';
// import { ToastrService } from 'ngx-toastr';
import { Modal } from 'bootstrap'

declare var d3: any;

@Component({
    selector: 'app-providerdashboard',
    templateUrl: './providerdashboard.component.html',
    styleUrls: ['./providerdashboard.component.scss'],
    providers: [MemberFilterArrayPipe, MemberSearchFilterPipe],
    standalone: false
})
export class ProviderDashboardComponent implements OnInit {
  queryParamsSub: any;
  loadQMDataSubscription: any;
  loadProviderAffiliationSubscription: any;
  loadExternalUserSiteSubscription: any;
  loadInternalUserSiteSubscription: any;
  loadProviderSubscription: any;
  starRatingSubscription: any;
  providerDashboardForm: UntypedFormGroup;
  showFlag = false;
  searchSiteForm: UntypedFormGroup;
  selectedSite: any; //= {id: 95, value: "LA/OC_ BOROUJERDI RAD, HASSAN"};
  showLookUp = false;
  showDialog = false;
  public gridRowSelectionSubscription: any;
  selectedProvider: any;
  provideSearchSites: IProviderSiteSearch;
  sites = [];
  testSites = [];
  selectedSiteId: any;
  providers: any[] = [];
  isInternalUser: boolean;
  showView: boolean;
  showNoRecords: boolean;
  showTabs: boolean;
  diseasesList: Array<any> = [];
  medDocUploadFlaglist: { [key: number]: string } = {};
  items: MenuItem[];
  activatedMenu: MenuItem;
  index: number = 0;
  memberProductUid: any;
  public providerAffiliationList: any[];
  @ViewChild('menuItems') menuItems: ElementRef;
  public urlConstant: any = this.urlconstantsService.fetchUrl();
  margin = { top: 5, right: 40, bottom: 20, left: 500 };
  width = 1100 - this.margin.left - this.margin.right;
  height = 50 - this.margin.top - this.margin.bottom;
  bulletdata = [];
  membersList = [];
  membersQmList = [];
  measureStatusList = [];
  statusFilterList = [
    { id: 1, value: 'MET' },
    { id: 2, value: 'NOT MET' }
  ];
  memberNameList: Array<any> = [];
  public hedisReport = 'HEDIS Report';
  showGenericReportModal: boolean;
  showGenericReport: boolean;
  public performanceDashboarForm: UntypedFormGroup;
  public hedisForm: UntypedFormGroup;
  showProviders = false;
  measureList: Array<any> = [];
  public sitePlaceHolder: string;
  public activeUserSites: any[];
  pcpList: any[] = [];
  public expandAll: boolean = true;
  public showCollapseAll: boolean = false;
  public accordionActiveIndex: any[] = [];
  public pcpIdFromURL: any;
  public siteIdFromURL: any;
  public qmDataGrpByMember = {};
  public selectedProduct = [];
  @Output() searchText = new EventEmitter<Array<any>>();
  searchInput: String;
  pcpChanged: boolean;
  public keys = [];
  commonSettingsForMultiSelect: {
    text: any;
    selectAllText: string;
    unSelectAllText: string;
    classes: string;
    badgeShowLimit: number;
    enableSearchFilter: boolean;
    maxHeight: any;
  };
  message: any;
  showSpinner = false;
  selectedProviderModel: any;
  data = [];
  selectedDisease: any = '';
  selectSegmentName: any = '';
  newQmDB: any = [];
  newQmDBStatusList: any = [];
  memberCount: any;
  qmDataFromService: any = [];
  openAccordianTab: boolean = false;
  openAccordianValue: any;
  activeTabs: boolean[] = [];
  combinedStar: any = [];
  contractName: any[] = [];
  SegmentNameDetails: any[] = [];
  disableDropDown: boolean = true;
  uploadFile: UntypedFormGroup;
  @ViewChild('inputFile', { static: false }) inputFile: ElementRef;
  selectedFiles: any[] = [];
  isRowVisible: boolean = false;
  indexOfClickedRow: any;
  currentMeasureDetails: any;
  totaldocumentsLength: number = 0;
  documentsLength: number = 0;
  lengthOfDocuments: boolean = false;
  qmUploadedDoc = [];
  selectedPcp: any;
  measureName: any;
  currentUsername: any;
  deleteItemId: string;
  selectedMemberId: any;
  qmUploadedDocLength: number;
  currentMemberDetails: any;
  activeMenuTab: any;
  // modalUploadDoc:any= new Modal(document.getElementById('uploadQmDoc'));
  sortedQmUploadedDoc: any;
  fullName: any;
  isInvalidFileType:boolean = false;
  private currentOpenRowIndex: number | null = null;
 selectedTab = "Measure View";
 activeTabValue;
 tabValue;
 // Multi-select HEDIS Report properties
 showMultiSelectHedisDialog = false;
 selectedSitesForHedis: any[] = [];
 selectedPcpsForHedis: any[] = [];
 selectedMeasuresForHedis: any[] = [];
 allSitesForHedis: any[] = [];
 allPcpsForHedis: any[] = [];
 allMeasuresForHedis: any[] = [];
 multiSelectHedisForm: UntypedFormGroup;
  handleResults(searchObj) {
    this.data = searchObj;
  }
  constructor(
    private cupService: CupService,
    private dateService: CupDateService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private urlconstantsService: UrlconstantsService,
    private fb: UntypedFormBuilder,
    private providerPortalService: ProviderportalService,
    private secureStorage: SecureStorageService
  ) {
    this.uploadFile = this.fb.group({
      file: [''],
    });
    //  this.subscription_GridRowSelected();
    this.initPerformanceDashboardForm();
    this.initHedisReportForm();
    this.initMultiSelectHedisForm();
    this.provideSearchSites = new IProviderSiteSearch();
    this.addListenerForHedisReportTabClick();
  }

  public initPerformanceDashboardForm() {
    this.performanceDashboarForm = this.fb.group({
      site: [''],
      pcp: [''],
    });
  }
  public initHedisReportForm() {
    this.hedisForm = this.fb.group({
      measure: [''],
      measureStatus: [''],
      measureDesc: [''],
      memberName: [''],
    });
  }
  public initMultiSelectHedisForm() {
    this.multiSelectHedisForm = this.fb.group({
      sites: [''],
      pcps: [''],
      status: [{ id: 2, value: 'NOT MET' }],
      measures: [''],
    });
  }
  private addListenerForHedisReportTabClick() {
    document.addEventListener('click', (element) => {
      if (
        element &&
        element.target &&
        (<any>element.target).childNodes &&
        (<any>element.target).childNodes.length > 0
      ) {
        if ((<any>element.target).childNodes[0].data === this.hedisReport) {
          if (this.membersList && Object.keys(this.membersList).length > 0) {
            this.openGenericReport();
          }
        }
      }
    });
  }
  private subscription_GridRowSelected() {
    this.gridRowSelectionSubscription = this.cupService.getPCPName.subscribe(
      (data: any) => {
        if (data) {
          //this.selectedProvider = { label: data.name, value: data };
        }
      }
    );
  }
  template1(row) {
    this.secureStorage.setSecureInfoInSessionlStorage('memberDetails', JSON.stringify(row) );
    this.secureStorage.setSecureInfoInSessionlStorage('memberSelected', 'true');
    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member');
    const userNameFromToken = this.cupService.getUserNameFromJWT();

    const dobFormatted = new customDateFilerPipe().transform(row.dob,'');
    let body = {
      "memberId": row.memberId, //"371M97362",
      "DOB": dobFormatted, // "07/26/1961",
      "memberActive": "All",
     //"lastName": ln[1], //"CHURCH" // "AGUEDA ROSSI",
    }
    this.showSpinner = true;
   this.cupService
   .retrieveData('post', urls.qmMemberSearch,body)
      .subscribe(
        data => {
          if (data && data.total) {
            //this.secureStorage.setSecureInfoInSessionlStorage('memberDetails', JSON.stringify(data.records[0]) );

            this.memberProductUid = data.records[0].memberProductId;
            // let path = this.urlConstant.memberSearch + data.records[0].id + '?memberproductuid=' +  data.records[0].memberProductId;
            let path = urls.qmgetMemeberDetails;
            let body = {
              "memberId": row.memberId, 
              "memberUid": data.records[0].id 
            
            }
             this.cupService
             .retrieveData('post', path,body)
            .subscribe(
              data => {
                if (data) {
                  this.secureStorage.setSecureInfoInSessionlStorage('memberDetails', JSON.stringify(data) );

                  let url = urls.qmgetQualityMeasureDetails;
                  let body = {
                    "memberId": data.hmoID
                  }
                   this.cupService
                   .retrieveData('post', url, body)
                  .subscribe(
                    async (resp) => {
                      if (resp) {          
                        const isValid = await this.providerPortalService.checkCupTokenValidity();
                        if (!isValid) {
                          this.openModal('CupJwtErrMsg')
                        this.showSpinner = false;
                          return;
                        } 
                       this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member/member-details/' +  data.id + '/0/' + this.memberProductUid);
                        window.open('../CUPPortal/#/singlesignon','_blank');
                        this.showSpinner = false;
                      }
                      else{
                        
                        this.showSpinner = false;
                      }
                    },err =>{
                      this.showSpinner = false;
                    })
                }else{
                  this.showSpinner = false;
                }
              },err =>{
                this.showSpinner = false;
              })
          }else{
            this.showSpinner = false;
            this.openModal('errorMessageModal');

          }
        },
        error => {
          this.showSpinner = false;
        }
      );
    // ../CUPPortal/#/singlesignon
  }

  ngOnInit() {
    if (this.items?.length) {
      this.activeTabValue = this.items[0].label;   // must match [value]="tab.label"
    }
    this.isInvalidFileType = false; 
    this.fullName = this.secureStorage.getSecureInfoInSessionStorage('fullName');
    this.currentUsername = this.cupService.getUserNameFromJWT();
    this.items = [
      { label: 'Measure View', icon: 'fa fa-fw fa-list' },
      { label: 'Member List View', icon: 'fa fa-fw fa-users' },
      { label: 'Measure Dashboard', icon: 'fa fa-fw fa-users' },
      // { label: 'Graph View', icon: 'fa fa-fw fa-bar-chart' }
    ];
    this.tabValue = this.items[0].label;
    this.activatedMenu = this.items[0];
    this.isInternalUser = this.cupService.isInternalUser();
    if (this.isInternalUser) {
      this.internalDashboard();
    } else {
      this.getExternalDashboard();
    }
    this.getPCPProviders();
  }

  onActivatedMenu(event) {
    this.indexOfClickedRow = null;
    this.qmUploadedDoc = [];
    this.currentMemberDetails = [];
    this.selectedMemberId = '';
    this.items.forEach((item) => {
      if (item.label === this.menuItems['activeItem']['label']) {
        this.activatedMenu = item;
      }
    });
    setTimeout(() => {
      this.onTabChange(event);
    }, 1000);
  }
  internalDashboard() {
    this.sites = [];
    this.activatedMenu = this.items[0];
    this.showSpinner = true;
    if (this.loadInternalUserSiteSubscription) {
      this.loadInternalUserSiteSubscription.unsubscribe();
    }
    this.loadInternalUserSiteSubscription = this.cupService
      .retrieveData('get', this.urlConstant.templateUserSite)
      .subscribe(
        (data) => {
          if (data) {
            if (data.sites && data.sites.length) {
              data.sites.map((element) => {
                this.sites.push({
                  id: element.siteUid,
                  value: element.siteName,
                });
              });
            }
            this.showView = true;
          }
          this.showSpinner = false;
        },
        (error) => {
          this.showSpinner = false;
        }
      );
  }

  filterMember() {
    if (!this.searchInput) {
      this.keys = Object.keys(this.qmDataGrpByMember);
    } else {
      let allMatchedRecords = [];
      if (this.qmDataGrpByMember && Array.isArray(this.qmDataGrpByMember)) {
        Object.keys(this.qmDataGrpByMember).forEach((memberId) => {
          let member = this.qmDataGrpByMember[memberId];

          if (member && member.membername) {
            let isMatched = member.membername
              .toLowerCase()
              .includes(this.searchInput.toLowerCase());
            if (isMatched) {
              allMatchedRecords.push(memberId);
            }
          }
        });
      }
      this.keys = allMatchedRecords;
    }
  }
  pcpAllSites = [];
  getPCPProviders() {
    const userNameFromToken = this.cupService.getUserNameFromJWT();
    this.providers = [];
    this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteProviders.replace(
      '{id}',
      userNameFromToken
      // JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('currentUser')).userName
    );
    setTimeout(() => {
      this.showSpinner = true;
    }, 100);
    let checkDuplicates = [];
    this.cupService.retrieveData('post', siteDetailURL).subscribe(
      (siteData) => {
        if (siteData && siteData.length) {
          siteData.map((each) => {
            if (each.providers && each.providers.length > 0) {
              let providerIds = [];
              each.providers.map((element) => {
                if (element.pcp && element.region.indexOf('OBSOLETE') === -1) {
                  element.value =
                    element.name +
                    '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                    element.region +
                    '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                    element.address.substring(0, 14);
                  element.providerUid = element.id;
                  element.id = element.providerId;
                  if (!checkDuplicates.includes(element.value)) {
                    checkDuplicates.push(element.value);
                    this.providers.push(element);
                  }
                  if (!providerIds.includes(element.providerId)) {
                    providerIds.push(element.providerId);
                  }
                }
              });
              this.pcpAllSites.push({
                value: { id: each.siteUid, value: each.name },
                uid: providerIds,
              });
            }
          });
        } else {
          this.diseasesList = [];
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }
  setInternalProviders() {
    this.providers = [];
    this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      (siteData) => {
        if (siteData) {
          if (
            siteData.siteProviderConfig &&
            !_.isEmpty(siteData.siteProviderConfig)
          ) {
            // this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map((element) => {
              if (
                element.neighborhood &&
                element.pcp &&
                element.region.indexOf('OBSOLETE') === -1
              ) {
                element.value =
                  element.name +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.region +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
          } else {
            this.diseasesList = [];
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }
  getProviders() {
    for (let i = 0; i < this.sites.length; i++) {
      if (this.sites[i].siteName === this.selectedSite.value) {
        return this.sites[i].siteProviderConfig;
      }
    }
  }
  setExternalProviders() {
    this.providers = [];
    this.activatedMenu = this.items[0];
    this.showProviders = false;
    const siteDetailURL = this.urlConstant.userSiteGet.replace(
      '{siteUid}',
      this.selectedSite.id
    );
    this.showSpinner = true;
    let checkDuplicates = [];
    this.cupService.retrieveData('get', siteDetailURL).subscribe(
      (siteData) => {
        if (siteData) {
          if (
            siteData.siteProviderConfig &&
            !_.isEmpty(siteData.siteProviderConfig)
          ) {
            //  this.providers = siteData.siteProviderConfig;
            siteData.siteProviderConfig.map((element) => {
              if (
                element.neighborhood &&
                element.pcp &&
                element.region.indexOf('OBSOLETE') === -1
              ) {
                element.value =
                  element.name +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.region +
                  '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                  element.address.substring(0, 14);
                element.providerUid = element.id;
                element.id = element.providerId;
                if (!checkDuplicates.includes(element.value)) {
                  checkDuplicates.push(element.value);
                  this.providers.push(element);
                }
              }
            });
            // this.selectedProvider = this.providers[0];
            // this.onProvidersSubmit(this.selectedProvider);
          } else {
            this.diseasesList = [];
          }
        }
        this.showProviders = true;
        this.showSpinner = false;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }

  setProviders(e) {
    this.selectedSite = e;
    this.showCollapseAll = false;
    this.sitePlaceHolder = '';
    this.providers = [];
    this.diseasesList = [];
    this.measureList = [];
    this.providerAffiliationList = [];
    this.unsubscribeAll();
    if (this.isInternalUser) {
      this.setInternalProviders();
    } else {
      this.setExternalProviders();
    }
    this.pcpChanged = true;
    //this.providerAffiliationList = [];
  }

  private getExternalDashboard() {
    this.sites = [];
    this.activatedMenu = this.items[0];
    const username = this.cupService.getUserNameFromJWT();
    const url = this.urlConstant.providerDashboard;
    this.showSpinner = true;
    this.cupService.retrieveData('post', url).subscribe(
      (data) => {
        if (data != null) {
          // this.sites = data.sites;
          if (data.sites && data.sites.length) {
            data.sites.map((element) => {
              this.sites.push({
                id: element.siteUid,
                value: element.siteName,
                label: element.siteName,
              });
            });
          }

          this.showView = true;
        }
        this.showSpinner = false;
      },
      (error) => {
        this.showSpinner = false;
      }
    );
  }
  public openPopup() {
    this.showLookUp = true;
    this.cupService.selectedProviderPCP(true);
    this.cupService.isRetainAdminPanelsOnClick(false, 'openUserSitePanel');
  }
  openGenericReport() {
    this.hedisForm.reset();
    this.showGenericReportModal = true;
  }
  public sendProviderDetails(event) {
    this.showLookUp = false;
    this.clearSearch();
    this.providers = [];
    this.sites = [];

    const siteDetailURL = this.urlConstant.userSiteSearch;
    this.provideSearchSites.page = '';
    this.provideSearchSites.size = '';
    this.provideSearchSites.siteTypeUid = '';
    this.provideSearchSites.description = '';
    this.provideSearchSites.providerContractUid = '';
    this.provideSearchSites.providerUid = event.id;
    this.showSpinner = true;

    this.cupService
      .retrieveData('post', siteDetailURL, this.provideSearchSites)
      .subscribe(
        (siteData) => {
          if (siteData && siteData.length) {
            this.sites = siteData;
            this.sites.map((element) => {
              element.value = element.description;
              element.id = element.siteUid;
            });
            // for (let index = 0; index < siteData.records.length; index++) {
            //   const element = siteData.records[index];
            //   this.sites.push({ label: element.description, value: element });
            // }
            this.selectedSite = this.sites[0].id;
            const siteProviderList =
              this.urlConstant.userSiteSave + siteData[0].siteUid;
            this.cupService
              .retrieveData('get', siteProviderList)
              .subscribe((providerData) => {
                this.providers = providerData.siteProviderConfig;
                this.providers.map((element) => {
                  // element.value = element.name;
                  if (element.neighborhood) {
                    element.value =
                      element.name +
                      '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                      element.region +
                      '\xa0\xa0\xa0\xa0-\xa0\xa0\xa0\xa0' +
                      element.address.substring(0, 14);
                  } else {
                    element.value = element.name;
                  }
                  element.providerUid = element.id;
                  element.id = element.providerId;
                });
                // if (data.providerId === event.providerId) {
                // const items = providerData.siteProviderConfig;
                const providerIndex = this.providers.findIndex(
                  (x) => x.providerId === event.providerId
                );
                const old_index = this.providers[providerIndex];
                this.providers[providerIndex] = this.providers[0];
                this.providers[0] = old_index;
                this.selectedProvider = this.providers[0];
                // }
              });
            this.showSpinner = false;
          } else {
            this.providers = [
              {
                id: event.providerId,
                value: event.name,
              },
            ];
            this.selectedProvider = this.providers[0];
            this.showSpinner = false;
          }
        },
        (error) => {
          this.showSpinner = false;
        }
      );

    this.cupService.selectedProviderPCP(false, event);
  }
  public closeProviderPopup() {
    this.cupService.isRetainAdminPanelsOnClick(true, 'openUserSitePanel');
    this.unsubscription_GridRowSelected();
  }
  private unsubscription_GridRowSelected() {
    if (this.gridRowSelectionSubscription) {
      this.gridRowSelectionSubscription.unsubscribe();
    }
  }
  /*Retain Panel*/
  public retainSearchSitePanel() {
    this.cupService.isRetainAdminPanelsOnClick(true, 'openUserSitePanel');
  }

  private loadProviderAffiliation(providerUid) {
    let jsonData = JSON.stringify({
      id: providerUid,
      affiliationType: ['P TO G', 'P TO I'],
    });
    if (this.loadProviderAffiliationSubscription) {
      this.loadProviderAffiliationSubscription.unsubscribe();
    }
    this.loadProviderAffiliationSubscription = this.cupService
      .retrieveData('post', urls.providerAffiliation, jsonData)
      .subscribe((data) => {
        if (Array.isArray(data)) {
          this.providerAffiliationList = data;
        }
      });
  }
  public onProvidersSubmit(selectedProvider) {
    this.qmUploadedDoc = [];
    this.indexOfClickedRow = null;
    this.selectedPcp = selectedProvider;
    this.showCollapseAll = false;
    this.diseasesList = [];
    this.measureList = [];
    if (selectedProvider != undefined) {
      if (!this.pcpChanged) {
        const pcp = _.find(this.pcpAllSites, (each) => {
          if (each.uid.includes(selectedProvider.id)) {
            return each;
          }
        });
        this.selectedSite = pcp.value;
      }

      let provider = this.getProviderInfoByValue(selectedProvider.value);
      this.selectedProvider = provider;
      this.activatedMenu = this.items[0];
      const regionCode = provider.regionCode;
      const id = provider.id + regionCode;
      const body = {
        siteId: this.selectedSite ? this.selectedSite.id : '',
        providerdId: provider ? provider.id : '',
      };
      this.showSpinner = true;
      this.diseasesList = [];
      this.measureList = [];
      this.providerAffiliationList = [];
      this.loadProviderAffiliation(provider.providerUid);
      this.getQmDashboardMemberData(id);
      this.getQmDashboardData(provider.id);
      this.getNewQmDashboardData(provider.id);
    }
  }
  public onTabChange(event) {
    //this.generateCharts();
    this.selectedDisease = '';
    this.selectSegmentName = '';
    this.contractName = [];
    this.disableDropDown = true;
  }

  generateCharts() {
    const bulletgraph = [];
    this.diseasesList.forEach((each) => {
      const obj = {};
      obj['title'] = each['dashboardDescription'];
      obj['subtitle'] = '';
      obj['ranges'] = [each['averagePercentage'], 100];
      obj['measures'] = [];
      obj['markers'] = [];
      obj['measures'].push(each['metAverage']);
      obj['markers'].push(each['targetPercentage']);
      obj['reverse'] = each['reverseGraph'];
      bulletgraph.push(obj);
    });
    const chart = d3.bullet().width(this.width).height(this.height);

    const svg = d3
      .select('#graphDiv')
      .selectAll('svg')
      .data(bulletgraph)
      .enter()
      .append('svg')
      .attr('class', 'bullet')
      .attr('width', this.width + this.margin.left + this.margin.right)
      .attr('height', this.height + this.margin.top + this.margin.bottom)
      .append('g')
      .attr(
        'transform',
        'translate(' + this.margin.left + ',' + this.margin.top + ')'
      )
      .call(chart);

    const title = svg
      .append('g')
      .style('text-anchor', 'end')
      .attr('transform', 'translate(-3,' + this.height / 2 + ')');

    title
      .append('text')
      .attr('class', 'title')
      .text(function (d) {
        return d.title;
      });

    title
      .append('text')
      .attr('class', 'subtitle')
      .attr('dy', '1em')
      .text(function (d) {
        return d.subtitle;
      });
  }

  // getMembersDetails() {
  //   this.showSpinner = true;
  //   const memberDetailsUrl = this.urlConstant.memberDetails.replace(
  //     '{memberid}',
  //     '72255'
  //   );
  //   this.cupService
  //     .retrieveData('get', memberDetailsUrl + '?memberproductuid=70872')
  //     .subscribe(
  //       data => {
  //         if (data) {
  //           this.secureStorage.setSecureInfoInSessionlStorage('memberDetails', JSON.stringify(data));
  //           setTimeout(() => {
  //             this.router.navigate([
  //               '/home/member/quality-measure/85',
  //               { skipLocationChange: true }
  //             ]);
  //           }, 300);
  //         }
  //         //   this.showSpinner = false;
  //       },
  //       error => {
  //         this.showSpinner = false;
  //       }
  //     );
  // }

  getMembersDetails(member) {
    /* this.showSpinner = true;
    const membersUrl = this.urlConstant.memberDetails.replace("/{memberid}", "");
    const insuranceCarrierIds = JSON.parse(this.secureStorage.getSecureInfoInSessionStorage('insuranceIds'));
    const body = {
      memberId: member.memberId,
      insuranceCarrier: insuranceCarrierIds,
      memberActive: "All",
      userId: this.cupService.getUserNameFromJWT()
    };
    this.cupService
      .retrieveData("post", membersUrl, body)
      .subscribe(membersData => {
        if (membersData && membersData.records) {
          const records = membersData.records;
          //this.secureStorage.setSecureInfoInSessionlStorage("membeTraversal", JSON.stringify(records));
          const memberList = records.sort((a, b) => {
            return new Date(a.planTermDate) < new Date(b.planTermDate) ? 0 : -1;
          });
          const memberDetailsUrl = this.urlConstant.memberDetails.replace(
            "{memberid}",
            memberList[0].id
          );
          this.cupService
            .retrieveData("get", memberDetailsUrl + "?memberproductuid=" + memberList[0].memberProductId)
            .subscribe(
              data => {
                if (data) {
                  data.memberProductUid = memberList[0].memberProductId;
                  this.secureStorage.setSecureInfoInSessionlStorage("memberDetails", JSON.stringify(data));
                  let site = this.performanceDashboarForm.get('site').value;
                  let pcp = this.performanceDashboarForm.get('pcp').value;

                  setTimeout(() => {
                    this.secureStorage.setSecureInfoInLocalStorage('targetUrl', 'member/quality-measure');
                    this.router.navigateByUrl("../CUPPortal/#/singlesignon");

                    // this.router.navigate(["../CUPPortal/#/singlesignon"]);

                    // this.router.navigate(["/home/member/quality-measure"],
                    // { skipLocationChange: true, queryParams: { redirectFromQMDashboard: true, siteuid: site.id, pcpid: pcp.id } });
                  }, 300);
                }
                //   this.showSpinner = false;
              },
              error => {
                this.showSpinner = false;
              }
            );
        }
      }); */
  }

  // public getQmDashboardData(selectedProvider) {

  //   //this.accordionActiveIndex = [];
  //   //const regionCode = selectedProvider.regionCode;
  //   this.diseasesList = [];
  //   this.measureList = [];
  //   return this.cupService.retrieveData("get", this.urlConstant.qmDashboard + selectedProvider)
  //     .subscribe(data => {
  //       if (data) {
  //         let index = 0;
  //         data.measures.map((items, i) => {
  //           items.measureDetails.forEach((disease) => {
  //             disease['measureId'] = items.measureId;

  //             disease["notMet"] = disease.denominator - disease.numerator;
  //             disease["metPercentage"] = Math.round(
  //               (disease["numerator"] / disease.denominator) * 100
  //             );
  //             disease["notMetPercentage"] = Math.round(
  //               (disease["NotMet"] / disease.denominator) * 100
  //             );
  //             const average = Math.round(
  //               (disease.numerator / disease.denominator) * 100
  //             );
  //             disease["metAverage"] = average;
  //             this.measureList.push({
  //               id: index,
  //               // value: disease.dashboardDescription
  //               itemName: disease.dashboardDescription,
  //               measureId: items.measureId,
  //             })

  //             disease.starRating = -1;

  //             //if(disease.dashboardDescription !== 'HbA1c <= 9 - HbA1c Good Control (< 7)'){
  //               const withReverseGraph = '0 - ' + disease.targetPercentage + '%';
  //               const withoutReverseGraph = disease.targetPercentage + ' - 100%';
  //               disease.targetGoal = disease.reverseGraph ? withReverseGraph : withoutReverseGraph;
  //             this.diseasesList.push(disease);
  //             //}

  //             //this.accordionActiveIndex.push(i);
  //             index++;
  //           });
  //         });
  //         this.measureList = this.cupService.deepCopy(this.measureList);

  //         this.getStarRating();
  //         this.showTabs = true;
  //       }
  //     });
  // }

  public getNewQmDashboardData(selectedProvider) {
    this.showSpinner = true;
    this.qmDataFromService = [];
    return this.cupService
      .retrieveData('get', this.urlConstant.newqmDashboard + selectedProvider)
      .subscribe((data) => {
        if (data) {
          this.qmDataFromService.push(data);
        }
      });
  }

  clickMe(memberId) {
    this.activeTabs = [];
    this.accordionActiveIndex = [];
    this.openAccordianTab = false;
    this.openAccordianValue = '';
    this.activatedMenu = this.items[0];
    this.tabValue = this.items[0].label;
    if (this.diseasesList) {

      this.diseasesList.filter((item, index) => {
        if (item.measureId == memberId) {
          let activeIndex = [];
          setTimeout(() => {
            this.activeTabs[index] = !this.activeTabs[index];
            activeIndex.push(index)
            this.accordionActiveIndex = activeIndex;
            document
              .getElementsByClassName(`dynamicStyleClass${index}`)[0]
              .scrollIntoView();
          }, 500);
        }
      });
    }
  }

  onQmDashboardChange(event) {
    this.memberCount = '';
    this.newQmDB = [];
    this.contractName = [];
    this.newQmDBStatusList = [];
    this.disableDropDown = true;
    this.selectSegmentName = "";
    let item = event.target.value;
  
  const statusCount = Object.keys(this.membersList)
  .filter((key) => key.includes(item))
  .reduce((object, key) => {
      return Object.assign(object, {
        [key]: this.membersList[key]
      });
  }, {});
  
    if(statusCount[item]) {
      if (statusCount[item].list.length > 0) {
        for (let i =0 ;i < statusCount[item].list.length; i++) {
          if (statusCount[item].list[i].status && statusCount[item].list[i].status == 'NOT MET')
          this.newQmDBStatusList.push(statusCount[item].list[i]);          
        }
        //console.log("newQmDBStatusList--:",this.newQmDBStatusList)
        this.memberCount = this.newQmDBStatusList.length;
      }
      else {
        this.newQmDBStatusList.push({
          'measureId' : item
        })
        this.memberCount = '';
  
        //this.newQmDBStatusList.length = '';
        //console.log("newQmDBStatusList in else part--:",this.newQmDBStatusList)
      }
      this.memberCount = this.newQmDBStatusList.length;
    }
    else {
      this.newQmDBStatusList.push({
        'measureId' : item
      })
      this.memberCount = '';
    }
  
    if(this.qmDataFromService.length > 0) {
      this.qmDataFromService[0].measures.filter((x) => {
        if(item == x.measureId) {
          this.newQmDB.push(x);
          this.contractName.push(x.segmentName) 
          if(this.contractName.length > 0){
            this.disableDropDown = false;
          }
        }
      })        
    }
  }
  

  onSegmentChange(event) {
    this.SegmentNameDetails = [];
    this.combinedStar = [];
    let segName = event.target.value;

    if (this.newQmDB.length > 0) {
      this.newQmDB.filter((x) => {
        if (segName == x.segmentName) {
          let reportDate = this.dateService.convertDateFormat(x.reportRunDate);
          this.SegmentNameDetails.push(x);
          this.SegmentNameDetails.push(reportDate);
        }
      });
      if (this.SegmentNameDetails[0]) {
        for (let i = 1; i <= this.SegmentNameDetails[0].combinedStar; i++)
          this.combinedStar.push(i);
      } else {
        this.combinedStar = [];
      }
    }
  }

  public getQmDashboardData(selectedProvider) {
    this.showNoRecords = false;
    //this.accordionActiveIndex = [];
    //const regionCode = selectedProvider.regionCode;
    this.diseasesList = [];
    this.measureList = [];
    this.showSpinner = true;
    this.cupService
      .getMeasureDescriptionFromEdh(selectedProvider)
      .subscribe((data) => {
        if (data) {
          let response;
          let index = 0;
          response = data;
          response.forEach((disease) => {
            disease['measureId'] = disease.measureId;
            disease['metPercentage'] = 0;
            disease['notMetPercentage'] = '';
            disease['metAverage'] = 0;
            disease['averagePercentage'] = 0;
            disease['targetPercentage'] = 0;

            this.measureList.push({
              id: index,
              // value: disease.dashboardDescription
              itemName: disease.measure,
              measureId: disease.measureId,
            });
            disease.starRating = -1; // Represent no star rating assigned

            this.diseasesList.push(disease);
            index++;
          });
          if (response.length == 0) {
            this.showNoRecords = true;
          }
          this.measureList = this.cupService.deepCopy(this.measureList);

          this.getStarRating();
          // this.showTabs = true;
        }
        this.showSpinner = false;
      });
  }

  getQmDashboardMemberData(provider: any) {
    //this.membersList: Array<any> = {};
    this.membersList = [];
    this.measureStatusList = [];
    this.qmDataGrpByMember = [];
    const regionCode = provider.regionCode;
    this.memberNameList = [];

    this.diseasesList = [];
    this.measureList = [];
    this.showSpinner = true;

    return this.cupService
      .retrieveData('get', this.urlConstant.qmMemberListView + provider)
      .subscribe((data) => {
        if (data) {
          data.memberMeasures.forEach((row) => {
            let list = [];

            row.memberDetails.forEach((member) => {
              let obj: any = {};
              obj.measure = row.measure;
              obj.measureId = row.measureId;
              obj.membername = member.firstName + ' ' + member.lastName;

              obj.memberId = member.memberId;
              obj.dob = member.dob;
              obj.gender = member.gender;
              obj.age = member.age;
              obj.memberAddress = member.memberAddress;
              obj.healthPlan =
                member.memberHealthPlan && member.memberHealthPlan.length > 0
                  ? member.memberHealthPlan[0]
                  : {};
              obj.eventdate = member.memberQmDetails.length
                ? this.dateService.convertDateFormat(
                    member.memberQmDetails[0].eventDate
                  )
                : ' ';
              obj.eventvalue = member.memberQmDetails.length
                ? member.memberQmDetails[0].eventValue
                : '';
              obj.exclusionNote = member.memberQmDetails.length
                ? member.memberQmDetails[0].excludedNote
                : '';
              obj.status = member.memberQmDetails.length
                ? member.memberQmDetails[0].status
                : '';
              obj.statusDesc = member.memberQmDetails.length
                ? member.memberQmDetails[0].statusDesc
                : '';
              list.push(obj);

              let keys = Object.keys(this.qmDataGrpByMember); // Return mem id list

              let isMemberAddedAlready = false;
              if (keys && keys.length > 0) {
                isMemberAddedAlready = keys.find(
                  (key) => member.memberId == key
                )
                  ? true
                  : false;
              }

              if (!isMemberAddedAlready) {
                this.qmDataGrpByMember[member.memberId] = {
                  memberId: member.memberId,
                  membername: member.firstName + ' ' + member.lastName,
                  dob: member.dob,
                  pcpName: this.selectedProvider.name,
                  measures: [
                    {
                      measureId: row.measureId,
                      measure: row.measure,
                      dueDate: obj.eventdate,
                      eventValue: obj.eventvalue,
                      status: obj.status,
                      eventNotes: obj.statusDesc,
                      excludedNote: obj.exclusionNote,
                    },
                  ],
                };
              } else {
                let memberWithMeasureData =
                  this.qmDataGrpByMember[member.memberId];
                if (!memberWithMeasureData.measures) {
                  memberWithMeasureData.measures = [];
                }
                if (row.measure != 'Medication Adherence - Diabetes (OralDb)') {
                  (<any[]>memberWithMeasureData.measures).push({
                    measureId: row.measureId,
                    measure: row.measure,
                    dueDate: obj.eventdate,
                    eventValue: obj.eventvalue,
                    status: obj.status,
                    eventNotes: obj.statusDesc,
                    excludedNote: obj.exclusionNote,
                  });
                }
              }

              if (obj.status) {
                let result = this.measureStatusList.find(
                  (x) => x.value == obj.status
                );
                if (!result) {
                  let tempId = this.measureStatusList.length + 1;
                  this.measureStatusList.push({
                    id: tempId,
                    value: obj.status,
                  });
                }
              }
              if (obj.membername) {
                let result = this.memberNameList.find(
                  (x) => x.value == obj.membername
                );

                if (!result) {
                  let tempId = this.memberNameList.length + 1;
                  this.memberNameList.push({
                    id: tempId,
                    value: obj.membername,
                  });
                }
              }
            });

            this.membersList[row.measureId] = {
              eventValueExists: row.eventValueExists,
              list: list,
            };
          });
          this.measureStatusList = this.cupService.deepCopy(
            this.measureStatusList
          );
          this.memberNameList = this.cupService.deepCopy(this.memberNameList);
          this.showTabs = true;
          this.keys = Object.keys(this.qmDataGrpByMember);
        }
        this.showSpinner = false;
      });
  }

  public downloadReport() {
    let filteredMembersList = this.getFilterMembers();

    filteredMembersList = filteredMembersList.filter(element => element.measure !== 'Medication Adherence - Diabetes (OralDb)');
    let pod = undefined;
    if (this.providerAffiliationList && this.providerAffiliationList.length > 0) {
        pod = this.providerAffiliationList.map(x => x.name).join(", ");
    }
    if (filteredMembersList && filteredMembersList.length > 0) {
        let formattedMember = filteredMembersList.map(member => {
            let address1_Data: any = {};
            if (member.memberAddress && member.memberAddress.length > 0) {
                address1_Data = member.memberAddress[0];
            }
            let obj = {
                measure: member.measure,
                memberId: member.memberId,
                membername: member.membername,
                dob: member.dob,
                gender: member.gender,
                address1: address1_Data.address1,
                address2: address1_Data.address2 ? address1_Data.address2 : " ",
                city: address1_Data.city,
                state: address1_Data.state,
                zip: address1_Data.zip,
                phone: address1_Data.phone,
                healthPlan: member.healthPlan.memberPlanDesc,
                effectiveDate: member.healthPlan.memberPlanEffectiveDate ? this.dateService.convertDateFormat(member.healthPlan.memberPlanEffectiveDate) : ' ',
                pod: pod ? pod : " ",
                Name: this.selectedProvider.name,
                Region: this.selectedProvider.neighborhood,
                eventDate: member.eventdate,
                eventValue: member.eventvalue ? member.eventvalue : " ",
                labValue: "",
                dueByDate: "",
            }

            return obj;
        });

        var headers = this.getCsvFileHeader();

        new ngxCsv(formattedMember, this.selectedProvider.providerId, { headers: headers });

    } else {
        this.message = 'No Records Found';
        this.openModal('alertModal');
    }
  }
  
  private getProviderInfo(providerUid: any) {
    if (this.providers && this.providers.length > 0) {
      return this.providers.find((x) => x.id == providerUid);
    }
  }

  private getProviderInfoByValue(providerUid: any) {
    if (this.providers && this.providers.length > 0) {
      return this.providers.find((x) => x.value == providerUid);
    }
  }

  private getCsvFileHeader() {
    return [
      'Measure',
      'Member ID',
      'Member Name',
      'DOB',
      'Gender',
      'Address1',
      'Address2',
      'City',
      'State',
      'Zip',
      'Phone',
      'Health Plan',
      'Effective Date',
      'POD',
      'PCP Name',
      'Region',
      'Status',
      'Event Date',
      'Event Value',
      'Lab Value',
      'Due By Date',
    ];
  }

  public getSettings(placeholderText, isSpecialty?: boolean) {
    this.commonSettingsForMultiSelect = {
      text: placeholderText,
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      classes: 'myclass custom-class',
      badgeShowLimit: 1,
      enableSearchFilter: true,
      maxHeight: 200,
    };
    return this.commonSettingsForMultiSelect;
  }

  public getFilterMembers() {
    let measureList = this.hedisForm.get('measure').value
      ? this.hedisForm.get('measure').value
      : '';
    let measureStatus = this.hedisForm.get('measureStatus').value
      ? this.hedisForm.get('measureStatus').value.value
      : '';
    let memberName = this.hedisForm.get('memberName').value
      ? this.hedisForm.get('memberName').value.value
      : '';

    let filteredMembersList = [];
    let isMeasureSelected =
      measureList && Array.isArray(measureList) && measureList.length > 0;
    let isFilterApplied =
      isMeasureSelected || measureStatus || memberName ? true : false;
    if (isFilterApplied) {
      // Measure Filter applying
      if (isMeasureSelected) {
        filteredMembersList = [];
        measureList.forEach((measure) => {
          if (this.membersList && this.membersList[measure.measureId]) {
            filteredMembersList = filteredMembersList.concat(
              <any[]>this.membersList[measure.measureId].list
            );
          }
        });
      }
      if (measureStatus) {
        // If other filter applied
        if (filteredMembersList && filteredMembersList.length > 0) {
          filteredMembersList = filteredMembersList.filter(
            (mem) => mem.status == measureStatus
          );
        } else {
          // If not other filter applied
          Object.keys(this.membersList).forEach((measureIdKey) => {
            let memberUnderMeasure: any[] = this.membersList[measureIdKey].list;
            if (memberUnderMeasure && memberUnderMeasure.length > 0) {
              let result = memberUnderMeasure.filter(
                (mem) => mem.status == measureStatus
              );
              filteredMembersList = filteredMembersList.concat(result);
            }
          });
        }
      }
      if (memberName) {
        // If other filter applied
        if (filteredMembersList && filteredMembersList.length > 0) {
          filteredMembersList = filteredMembersList.filter(
            (mem) => mem.membername == memberName
          );
        } else {
          // If not other filter applied
          Object.keys(this.membersList).forEach((measureIdKey) => {
            let memberUnderMeasure: any[] = this.membersList[measureIdKey].list;
            if (memberUnderMeasure && memberUnderMeasure.length > 0) {
              let result = memberUnderMeasure.filter(
                (mem) => mem.membername == memberName
              );
              filteredMembersList = filteredMembersList.concat(result);
            }
          });
        }
      }
    } else {
      filteredMembersList = [];
      this.diseasesList.forEach((disease) => {
        if (this.membersList[disease.measureId]) {
          let memberUnderMeasure: any[] = this.membersList[disease.measureId]
            .list
            ? this.membersList[disease.measureId].list
            : '';
          if (memberUnderMeasure && memberUnderMeasure.length > 0) {
            filteredMembersList =
              filteredMembersList.concat(memberUnderMeasure);
          }
        }
      });
    }

    return filteredMembersList;
  }

  public getStarRating() {
    try {
      this.medDocUploadFlaglist = {};

      if (this.diseasesList && this.diseasesList.length > 0) {
        let starRatingCallList: Observable<any>[] = [];
        this.diseasesList.forEach((measure) => {
          //let url = this.urlconstantsService.fetchUrl().measureStarRating.replace("{measureId}", measure.measureId).replace("{targetPercent}", measure.metPercentage);
          // let url = urls.measureStarRating.replace("{measureId}", measure.measureId).replace("{targetPercent}", measure.metPercentage);

          const negativeMeasure = '-' + measure.measureId;
          let url = urls.measureStarRating
            .replace(
              '{measureId}',
              measure.reverseGraph ? negativeMeasure : measure.measureId
            )
            .replace('{targetPercent}', measure.metPercentage);

          let starRatingCall = this.cupService.getstartRating(url).pipe(
            map((value: any) => {
              measure.starRating = value;
              measure.pcpIncentive = value.pcpIncentive;
              this.medDocUploadFlaglist[measure.measureId] = value.medRecordsUpload;
            })
          );

          starRatingCallList.push(starRatingCall);
        });
        if (starRatingCallList && starRatingCallList.length > 0) {
          this.starRatingSubscription =
            forkJoin(starRatingCallList).subscribe();
        }
      }
    } catch (err) {
      throw err;
    }
  }

  clearSearch() {
    this.sitePlaceHolder = 'Select Site';
    this.unsubscribeAll();
    this.showSpinner = false;
    if (
      this.isInternalUser &&
      this.activeUserSites &&
      this.activeUserSites.length > 0
    ) {
      this.sites = this.cupService.deepCopy(this.activeUserSites);
    }
    this.performanceDashboarForm.reset();
    this.providers = [];
    this.pcpList = [];
    this.providerAffiliationList = [];
    this.diseasesList = [];
    this.measureList = [];
    //this.membersList = {};
    this.providerAffiliationList = [];
  }

  public expandAllPanels() {
    if (this.showCollapseAll) {
      // Collapse All Clicked
      this.accordionActiveIndex = [];
      this.showCollapseAll = false;
    } else {
      let activeIndex = [];
      this.diseasesList.forEach((x, index) => activeIndex.push(index));
      this.accordionActiveIndex = activeIndex;
      this.showCollapseAll = true;
    }
  }

  public accordionTabOpened(openedTabIndex) {
    let exist =
      this.accordionActiveIndex.filter((index) => index == openedTabIndex)
        .length > 0
        ? true
        : false;
    if (!exist) {
      this.accordionActiveIndex.push(openedTabIndex);
    }
    if (
      this.accordionActiveIndex &&
      this.accordionActiveIndex.length == this.diseasesList.length
    ) {
      this.showCollapseAll = true;
    }
  }

  public accordionTabClosed(closedTabIndex) {
    let exist =
      this.accordionActiveIndex.filter((index) => index == closedTabIndex)
        .length > 0
        ? true
        : false;
    if (exist) {
      let index = this.accordionActiveIndex.findIndex(
        (x) => x == closedTabIndex
      );
      this.accordionActiveIndex.splice(index, 1);
    }
    if (this.accordionActiveIndex && this.accordionActiveIndex.length == 0) {
      this.showCollapseAll = false;
    }
  }

  private unsubscribeAll() {
    if (this.loadQMDataSubscription) {
      this.loadQMDataSubscription.unsubscribe();
    }
    if (this.loadProviderAffiliationSubscription) {
      this.loadProviderAffiliationSubscription.unsubscribe();
    }
    if (this.loadExternalUserSiteSubscription) {
      this.loadExternalUserSiteSubscription.unsubscribe();
    }
    if (this.loadInternalUserSiteSubscription) {
      this.loadInternalUserSiteSubscription.unsubscribe();
    }
    if (this.loadProviderSubscription) {
      this.loadProviderSubscription.unsubscribe();
    }
    if (this.queryParamsSub) {
      this.queryParamsSub.unsubscribe();
    }
    if (this.starRatingSubscription) {
      this.starRatingSubscription.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unsubscribeAll();
  }

  public clearHedisReportFilter() {
    this.hedisForm.reset();
  }
  searchFilter() {
    let searchObject = [];
    searchObject.push(this.searchInput);
  }

  onMeasureSelect(disease:any){
    this.measureName = disease.measure;
      }
    
      //  Quality measure document upload section
      onCloseModal(){
        this.isInvalidFileType=false;
        this.selectedFiles=[];
      }
    
      uploadQmeasureMedicalDoc(rowId,memberDetails,activeTab:any){
        this.openModal('uploadQmDocModal');
        this.activeMenuTab=activeTab;
        this.currentMeasureDetails=memberDetails;
        this.documentCount(memberDetails,activeTab);
    
      }
      uploadQmDocs(){
        this.closeModal('uploadQmDocModal');
        this.onUpload(this.selectedFiles,this.currentMeasureDetails,this.activeMenuTab);
        
        // for (let i = 0; i < this.selectedFiles.length; i++) {
        //   this.onUpload(this.selectedFiles[i],this.currentMeasureDetails);              
        // }
    
      }
      onUpload(files:File[],memberDetails,activeMenutab){
        this.showSpinner = true;
        if(this.providerAffiliationList.length>0){
          let documentDetails:any;
        let medicalRecord:any;
        if(activeMenutab=="member"){
          
        documentDetails = {
          appId: "PP",
          createdUser: this.currentUsername,
          documentCode: "QMC_DOC",
          keyValuePairList: [
            { key: "DocumentTitle", value: files[0].name },
            { key: "MemberName", value: memberDetails.membername},
            { key: "MeasureName", value: memberDetails.measure },
            { key: "MemberID", value: memberDetails.memberId},
            { key: "PCPID", value: this.selectedPcp.id },
            { key: "SubmittedDate", value: new Date() .toISOString().slice(0, 19).replace('T', ' ') },
            { key: "PCPName", value: this.selectedPcp.value },
            { key: "PPUserName", value: this.fullName },
            { key: "Doctype", value: "Patient Chart" },
            { key: "Year", value:  new Date().getFullYear().toString() }
          ],
          txnLog: "false"
        };
        medicalRecord = {
          podName: this.providerAffiliationList.map(provider => provider.name).join(','),
          pcpName: this.selectedPcp.value,
          measureName:memberDetails.measure,
          patientName: memberDetails.membername,
          memberId: memberDetails.memberId,
          dob: memberDetails.dob
      };
    
        }else{
        documentDetails = {
          appId: "PP",
          createdUser: this.currentUsername,
          documentCode: "QMC_DOC",
          keyValuePairList: [
            { key: "DocumentTitle", value: files[0].name },
            { key: "MemberName", value: this.currentMemberDetails.membername},
            { key: "MeasureName", value: memberDetails.measure },
            { key: "MemberID", value: this.currentMemberDetails.memberId},
            { key: "PCPID", value: this.selectedPcp.id },
            { key: "SubmittedDate", value: new Date() .toISOString().slice(0, 19).replace('T', ' ') },
            { key: "PCPName", value: this.currentMemberDetails.pcpName },
            { key: "PPUserName", value: this.fullName },
            { key: "Doctype", value: "Patient Chart" },
            { key: "Year", value:  new Date().getFullYear().toString() }
          ],
          txnLog: "false"
        };
        medicalRecord = {
          podName: this.providerAffiliationList.map(provider => provider.name).join(','),
          pcpName: this.currentMemberDetails.pcpName,
          measureName:memberDetails.measure,
          patientName: memberDetails.membername,
          memberId: this.currentMemberDetails.memberId,
          dob: this.currentMemberDetails.dob
      };
    
        }
        this.providerPortalService.saveQmDocumentDetails(files,documentDetails,medicalRecord).subscribe(res=>{
          if(res){
            this.showSpinner = false;
            this.selectedFiles=[];
           
            this.openModal('docUploadedSuccessModal');
            this.showDoc(this.indexOfClickedRow,memberDetails,activeMenutab);
       
      }else{
        this.showSpinner = false;
        this.selectedFiles=[];
    
          }
        },(error)=>{
          this.selectedFiles=[];
          this.showSpinner = false;
          this.openModal('docUploadedErrorModal');
        })
    

        }else{
          this.showSpinner = false;
          this.openModal('docListUpdateErrorModal');
          this.selectedFiles=[];

        }
        
      }
    
      selectedFile(event:any,inputfileElement){
        this.isInvalidFileType=false;
        
        const newFiles = Array.from(inputfileElement.files);
        this.addFiles(newFiles,inputfileElement);
      }
      addFiles(newFiles: any[],inputfileElement) {
        return new Promise<void>((resolve) => {
          newFiles.forEach(file => {
            const fileExtension=file.name.split('.').pop().toLowerCase();
            if(fileExtension=== 'pdf' || fileExtension === 'docx' || fileExtension=== 'doc' || fileExtension=== 'xlsx' || fileExtension=== 'xls' || fileExtension=== 'ppt' || fileExtension=== 'pptx' || fileExtension==='jpg' || fileExtension==='jpeg' || fileExtension==='png'){
            if (!this.selectedFiles.some(existingFile => existingFile.name === file.name && existingFile.size === file.size)) {
              this.selectedFiles.push(file);
            }
          }else{
            this.isInvalidFileType=true;}
        }); 
        this.selectedFiles.forEach(file=>{
          if(file.name.split('.').pop() === 'pdf'){
            file['fileType'] = 'pdf';
          }else if(file.name.split('.').pop() === 'docx' || file.name.split('.').pop() === 'doc'){
            file['fileType'] = 'docx';}
        });
        resolve();
      }).then(() => {
        inputfileElement.value = '';
        this.proccedToCountUplaodFile(this.selectedFiles);
      });
      }
      ngAfterViewInit() {
        const dropArea = document.querySelector('.doccontainer');
        
        dropArea.addEventListener('dragover', (event) => {
          event.preventDefault();
          dropArea.classList.add('dragover');
        });
    
        dropArea.addEventListener('dragleave', () => {
          dropArea.classList.remove('dragover');
        });
    
        dropArea.addEventListener('drop', (event:DragEvent) => {
          event.preventDefault();
          dropArea.classList.remove('dragover');
          const files = event.dataTransfer?.files;
          if (files.length > 0) {
            const inputFileElement = this.inputFile.nativeElement as HTMLInputElement;
            inputFileElement.files = files;
            const changeEvent = new Event('change');
            inputFileElement.dispatchEvent(changeEvent);
            this.selectedFile(changeEvent, inputFileElement);
          }
        });
      }
      proccedToCountUplaodFile(file:any){
        this.totaldocumentsLength = file.length+this.documentsLength;
        
        if(this.totaldocumentsLength > 10){
          this.lengthOfDocuments = true;
        }else{
          this.lengthOfDocuments = false;
        }
        
      }
    
    
      showDoc(i:any,members:any,activeItem:any){
        this.showSpinner = true;
        this.qmUploadedDoc=[];
        let kvpl: { key: string, value: string }[] = [];
       
       
          this.indexOfClickedRow = i;
        this.isRowVisible = !this.isRowVisible;
       
    if(activeItem=="member"){
      this.selectedMemberId=members.memberId;
      kvpl=[
        { key: "MemberID", value: members.memberId},
        {key: "MeasureName", value: members.measure}
       ];
    }else{
      
      this.selectedMemberId=members.measureId;
       kvpl=[
        { key: "MemberID", value: this.currentMemberDetails.memberId},
        {key: "MeasureName", value: members.measure}
       ];
    
    }
    
        // const kvpl=[
        //  { key: "MemberID", value: members.memberId},
        //  {key: "MeasureName", value: this.measureName.substring(0, 60)}
        // ];
        this.providerPortalService.getListOfFileNetDocuments(kvpl,"QMC_DOC").subscribe((res:any)=>{
          
          if(res){
            this.sortedQmUploadedDoc=[];
            this.showSpinner = false;
            if (res.keyValuePairListWrapperlist && res.keyValuePairListWrapperlist.length > 0) {
              this.sortedQmUploadedDoc = res.keyValuePairListWrapperlist.sort((a: any, b: any) => {
                const keyValuePairWrA = a.keyvaluePairWr || [];
                const keyValuePairWrB = b.keyvaluePairWr || [];
                const createdDateA= keyValuePairWrA.find((x:any)=>x.key === 'UpdatedDate')?.value;
                const createdDateB= keyValuePairWrB.find((x:any)=>x.key === 'UpdatedDate')?.value;
                const dateA =createdDateA? new Date(createdDateA).getTime():0;
                const dateB =createdDateB? new Date(createdDateB).getTime():0;
                return dateB - dateA;
            });
            this.qmUploadedDoc = this.generateList(this.sortedQmUploadedDoc);
                this.qmUploadedDocLength = this.qmUploadedDoc.length;
            }else{
              this.showSpinner = false;
              this.qmUploadedDoc = [];
              this.qmUploadedDocLength = 0;
            }
          }else{
            this.showSpinner = false;
            this.qmUploadedDoc = [];
            this.qmUploadedDocLength = 0;
          }
         
        },error=>{
          this.openModal('docListUpdateErrorModal');
          this.showSpinner = false;
          this.qmUploadedDoc = [];
          this.qmUploadedDocLength = 0;
        });
      }
    
      isTableOpen(index: number): boolean {
        return this.indexOfClickedRow === index;
      }
    
      generateList(list) {
        let array = [];
        list.map((row) => {
          let obj: { [key: string]: any } = { Id: '' }; // Ensure 'Id' property exists
          row.keyvaluePairWr.map((item) => {
            obj[item.key] = item.value;
          });
          if (obj['DocumentTitle']) {
            const fileType = obj.DocumentTitle.split('.').pop();
            obj.type = fileType;
          }
          array.push(obj);
        });
        return array;
      }
    
      documentCount(members:any,activeItem:any){
        this.totaldocumentsLength = 0;
        this.qmUploadedDocLength = 0;
        this.lengthOfDocuments=false;
        let kvpl: { key: string, value: string }[] = [];
    
        if(activeItem=="member"){
          this.selectedMemberId=members.memberId;
          kvpl=[
            { key: "MemberID", value: members.memberId},
            {key: "MeasureName", value: members.measure}
           ];
        }else{
          
          this.selectedMemberId=members.measureId;
           kvpl=[
            { key: "MemberID", value: this.currentMemberDetails.memberId},
            {key: "MeasureName", value: members.measure}
           ];
        
        }
        this.providerPortalService.getListOfFileNetDocuments(kvpl,"QMC_DOC").subscribe((res:any)=>{
          
          if(res){
            this.documentsLength=res.keyValuePairListWrapperlist.length;
            if(this.documentsLength >= 10){
              this.lengthOfDocuments=true;
            }else{
              this.lengthOfDocuments=false;
            }
          }
         
        });
    
      
    
        
    
    
      }
      removeFile(file:File){
        this.selectedFiles = this.selectedFiles.filter(f => f.name !== file.name);
    
        this.totaldocumentsLength = this.selectedFiles.length+this.documentsLength;
        if(this.totaldocumentsLength > 10){
          this.lengthOfDocuments = true;
        }else{
          this.lengthOfDocuments = false;
        }
    
      }
    
      showDeleteModel(doc:any){
        this.deleteItemId="";
        this.deleteItemId=doc.Id;
        this.openModal('deleteModal');
        
    
      }
      deleteUploadedDoc(){
        if(this.deleteItemId!==""){
          this.providerPortalService.deleteuploadedDoc(this.deleteItemId).subscribe((res:any)=>{
            if(res){
            this.qmUploadedDoc=this.qmUploadedDoc.filter((f:any )=>f.Id !== this.deleteItemId);
            this.deleteItemId=="";
          }
          },(error)=>{
            this.openModal('docDeleteErrorModal');
          })
        }else{
          this.deleteItemId=="";
        }
    
      }
      closeRow() {
        this.indexOfClickedRow = null;
      }
    
      onViewDocument(doc:any){
        this.providerPortalService
          .getQmDocument(doc.Id, doc.DocumentClass, null)
          .subscribe((res) => {
            const responseData = res;
            if (navigator.appVersion.toString().indexOf(".NET") > 0) {
              const blob = this.binary64ToBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              saveAs(blob, responseData.filename);
              // this.loadingDashboard = false;
            } else {
              const blob = this.b64toBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              const urlBlob = URL.createObjectURL(blob);
               window.open(urlBlob, "_blank");
              // this.loadingDashboard = false;
            }
          });
        
      }
    
      getDocument(doc) {
        // this.loadingDashboard = true;
        this.providerPortalService
          .getQmDocument(doc.Id, doc.DocumentClass, null)
          .subscribe((res) => {
            const responseData = res;
    
            if (navigator.appVersion.toString().indexOf(".NET") > 0) {
              const blob = this.binary64ToBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              saveAs(blob, responseData.filename);
              // this.loadingDashboard = false;
            } else {
              const blob = this.b64toBlob(
                responseData.docContent,
                responseData.fileType,
                512
              );
              saveAs(blob, responseData.filename);
            }
          });
      }
    
      binary64ToBlob(binary64String, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;
    
        const byteCharacters = atob(binary64String);
        const byteArrays = [];
    
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      }
    
      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || "";
        sliceSize = sliceSize || 512;
        const byteCharacters = atob(b64Data);
        const byteArrays = [];
        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          const slice = byteCharacters.slice(offset, offset + sliceSize);
          const byteNumbers = new Array(slice.length);
          for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }
          const byteArray = new Uint8Array(byteNumbers);
          byteArrays.push(byteArray);
        }
        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
      }
      toggleRow(rowIndex: number, memId: string, memberDetails: any) {
        // Call the onCurrentMemberSelect function
        this.onCurrentMemberSelect(memId, memberDetails);
        // Close the currently opened row if it is different from the clicked row
        if (this.currentOpenRowIndex !== null && this.currentOpenRowIndex !== rowIndex) {
            const currentOpenRow = document.getElementById('demo' + this.currentOpenRowIndex);
            if (currentOpenRow) {
                currentOpenRow.classList.remove('show');
            }
        }

        // Toggle the clicked row
        const row = document.getElementById('demo' + rowIndex);
        if (row) {
            row.classList.toggle('show');
        }

        // Update the currently opened row index
        this.currentOpenRowIndex = row.classList.contains('show') ? rowIndex : null;

        
    }
    
      onCurrentMemberSelect(memberId:any,memberDetails:any){
        this.currentMemberDetails=memberDetails;
        this.indexOfClickedRow='';
        this.qmUploadedDoc=[];
    
      }

      // Multi-select HEDIS Report methods
      public openMultiSelectHedisDialog() {
        this.showMultiSelectHedisDialog = true;
        this.loadAllSitesAndPcps();
      }

      public closeMultiSelectHedisDialog() {
        this.showMultiSelectHedisDialog = false;
        this.multiSelectHedisForm.reset({
          sites: '',
          pcps: '',
          status: { id: 2, value: 'NOT MET' },
          measures: ''
        });
        this.selectedSitesForHedis = [];
        this.selectedPcpsForHedis = [];
        this.selectedMeasuresForHedis = [];
        this.allMeasuresForHedis = [];
      }

      private loadAllSitesAndPcps() {
        // Load all sites - use pcpAllSites if sites array is empty
        if (this.sites && this.sites.length > 0) {
          this.allSitesForHedis = this.sites.map((site: any) => ({
            id: site.id,
            itemName: site.value || site.label
          }));
        } else if (this.pcpAllSites && this.pcpAllSites.length > 0) {
          // Extract unique sites from pcpAllSites
          const uniqueSites = new Map<any, any>();
          this.pcpAllSites.forEach((siteData: any) => {
            if (siteData.value && siteData.value.id) {
              uniqueSites.set(siteData.value.id, {
                id: siteData.value.id,
                itemName: siteData.value.value
              });
            }
          });
          this.allSitesForHedis = Array.from(uniqueSites.values());
        }

        // Load all PCPs
        if (this.providers && this.providers.length > 0) {
          this.allPcpsForHedis = this.providers.map((provider: any) => ({
            id: provider.id,
            itemName: provider.value
          }));
        }

        // Load all Measures from diseasesList
        if (this.diseasesList && this.diseasesList.length > 0) {
          const uniqueMeasures = new Map<any, any>();
          this.diseasesList.forEach((disease: any) => {
            if (disease.measureId && disease.measure) {
              uniqueMeasures.set(disease.measureId, {
                id: disease.measureId,
                itemName: disease.measure,
                value: disease.measure
              });
            }
          });
          this.allMeasuresForHedis = Array.from(uniqueMeasures.values());
        }
      }

      public onSiteSelectionChange(event: any) {
        // Filter PCPs based on selected sites
        if (this.selectedSitesForHedis && this.selectedSitesForHedis.length > 0) {
          const selectedSiteIds = this.selectedSitesForHedis.map((site: any) => site.id);
          const filteredPcps: any[] = [];
          
          selectedSiteIds.forEach((siteId: any) => {
            const siteProviders: any = this.pcpAllSites.find((s: any) => s.value.id === siteId);
            if (siteProviders && siteProviders.uid && Array.isArray(siteProviders.uid)) {
              siteProviders.uid.forEach((providerId: any) => {
                const provider = this.providers.find((p: any) => p.id === providerId);
                if (provider && !filteredPcps.find((fp: any) => fp.id === provider.id)) {
                  filteredPcps.push({
                    id: provider.id,
                    itemName: provider.value
                  });
                }
              });
            }
          });
          
          this.allPcpsForHedis = filteredPcps;
        } else {
          // If no sites selected, show all PCPs
          this.allPcpsForHedis = this.providers.map((provider: any) => ({
            id: provider.id,
            itemName: provider.value
          }));
        }
        
        // Load measures when selection changes
        this.loadMeasuresForSelectedSitesAndPcps();
      }

      public onPcpSelectionChange(event: any) {
        // Load measures when PCP selection changes
        this.loadMeasuresForSelectedSitesAndPcps();
      }

      private loadMeasuresForSelectedSitesAndPcps() {
        // Only load if at least one site or PCP is selected
        if (!this.selectedSitesForHedis.length && !this.selectedPcpsForHedis.length) {
          this.allMeasuresForHedis = [];
          return;
        }

        this.showSpinner = true;
        const selectedProviderIds = this.selectedPcpsForHedis.map((pcp: any) => pcp.id);
        const selectedSiteIds = this.selectedSitesForHedis.map((site: any) => site.id);

        // Collect provider IDs to load data for
        const providerIdsToLoad: any[] = [];

        if (selectedProviderIds.length > 0) {
          selectedProviderIds.forEach((providerId: any) => {
            const provider = this.providers.find((p: any) => p.id === providerId);
            if (provider && provider.providerId) {
              providerIdsToLoad.push({
                providerId: provider.providerId,
                provider: provider
              });
            }
          });
        } else if (selectedSiteIds.length > 0) {
          // If only sites selected, get all PCPs for those sites
          selectedSiteIds.forEach((siteId: any) => {
            const siteProviders: any = this.pcpAllSites.find((s: any) => s.value.id === siteId);
            if (siteProviders && siteProviders.uid && Array.isArray(siteProviders.uid)) {
              siteProviders.uid.forEach((providerId: any) => {
                const provider = this.providers.find((p: any) => p.id === providerId);
                if (provider && provider.providerId && !providerIdsToLoad.find(p => p.providerId === provider.providerId)) {
                  providerIdsToLoad.push({
                    providerId: provider.providerId,
                    provider: provider
                  });
                }
              });
            }
          });
        }

        if (providerIdsToLoad.length === 0) {
          this.showSpinner = false;
          this.allMeasuresForHedis = [];
          return;
        }

        // Load QM data for all selected providers to get measures
        const measurePromises: Observable<any>[] = providerIdsToLoad.map(item => 
          this.loadQMDataForProviderStructured(item.providerId, item.provider)
        );

        forkJoin(measurePromises).subscribe(
          (results: any[]) => {
            const uniqueMeasures = new Map<any, any>();
            
            results.forEach(result => {
              if (result.diseasesList) {
                result.diseasesList.forEach((disease: any) => {
                  if (disease.measureId && disease.measure && disease.measure !== 'Medication Adherence - Diabetes (OralDb)') {
                    uniqueMeasures.set(disease.measureId, {
                      id: disease.measureId,
                      itemName: disease.measure,
                      value: disease.measure
                    });
                  }
                });
              }
            });
            
            this.allMeasuresForHedis = Array.from(uniqueMeasures.values());
            this.showSpinner = false;
          },
          (error) => {
            console.error('Error loading measures:', error);
            this.showSpinner = false;
            this.allMeasuresForHedis = [];
          }
        );
      }

      get isMultiSelectHedisReportDisabled(): boolean {
        return !this.selectedSitesForHedis.length && !this.selectedPcpsForHedis.length;
      }

      public generateMultiSelectHedisReport() {
        if (!this.selectedSitesForHedis.length && !this.selectedPcpsForHedis.length) {
          this.message = 'Please select at least one Site or PCP';
          this.openModal('alertModal');
          return;
        }

        this.showSpinner = true;
        const selectedProviderIds = this.selectedPcpsForHedis.map((pcp: any) => pcp.id);
        const selectedSiteIds = this.selectedSitesForHedis.map((site: any) => site.id);

        // Collect provider IDs to load data for
        const providerIdsToLoad: any[] = [];

        if (selectedProviderIds.length > 0) {
          selectedProviderIds.forEach((providerId: any) => {
            const provider = this.providers.find((p: any) => p.id === providerId);
            if (provider && provider.providerId) {
              providerIdsToLoad.push({
                providerId: provider.providerId,
                provider: provider
              });
            }
          });
        } else if (selectedSiteIds.length > 0) {
          // If only sites selected, get all PCPs for those sites
          selectedSiteIds.forEach((siteId: any) => {
            const siteProviders = this.pcpAllSites.find((s: any) => s.value.id === siteId);
            if (siteProviders && siteProviders.uid) {
              siteProviders.uid.forEach((providerId: any) => {
                const provider = this.providers.find((p: any) => p.id === providerId);
                if (provider && provider.providerId) {
                  providerIdsToLoad.push({
                    providerId: provider.providerId,
                    provider: provider
                  });
                }
              });
            }
          });
        }

        if (providerIdsToLoad.length === 0) {
          this.showSpinner = false;
          this.message = 'No providers found for the selected sites/PCPs';
          this.openModal('alertModal');
          return;
        }

        // Load QM data for all selected providers
        const reportPromises: Observable<any>[] = providerIdsToLoad.map(item => 
          this.loadQMDataForProviderStructured(item.providerId, item.provider)
        );

        forkJoin(reportPromises).subscribe(
          (results: any[]) => {
            // Combine all membersList from all providers
            const combinedMembersList: any = {};
            const combinedDiseasesList: any[] = [];
            const diseaseMap = new Map();

            results.forEach(result => {
              if (result.membersList) {
                // Merge membersList
                Object.keys(result.membersList).forEach(measureId => {
                  if (!combinedMembersList[measureId]) {
                    combinedMembersList[measureId] = {
                      list: [],
                      measure: result.membersList[measureId].measure
                    };
                  }
                  if (result.membersList[measureId].list) {
                    combinedMembersList[measureId].list.push(...result.membersList[measureId].list);
                  }
                });
              }
              
              if (result.diseasesList) {
                // Merge diseasesList (unique by measureId)
                result.diseasesList.forEach((disease: any) => {
                  if (!diseaseMap.has(disease.measureId)) {
                    diseaseMap.set(disease.measureId, disease);
                    combinedDiseasesList.push(disease);
                  }
                });
              }
            });

            // Use the same logic as downloadReport
            let filteredMembersList: any[] = [];
            const memberMap = new Map(); // To track unique member-measure combinations
            
            combinedDiseasesList.forEach((disease) => {
              if (combinedMembersList[disease.measureId]) {
                let memberUnderMeasure: any[] = combinedMembersList[disease.measureId].list
                  ? combinedMembersList[disease.measureId].list
                  : [];
                if (memberUnderMeasure && memberUnderMeasure.length > 0) {
                  // Deduplicate members by memberId + measureId combination
                  memberUnderMeasure.forEach(member => {
                    const uniqueKey = `${member.memberId}_${member.measureId}`;
                    if (!memberMap.has(uniqueKey)) {
                      memberMap.set(uniqueKey, member);
                      filteredMembersList.push(member);
                    }
                  });
                }
              }
            });

            console.log('Total records before deduplication:', filteredMembersList.length);
            console.log('Unique member-measure combinations:', memberMap.size);

            // Filter out 'Medication Adherence - Diabetes (OralDb)'
            filteredMembersList = filteredMembersList.filter(element => 
              element.measure !== 'Medication Adherence - Diabetes (OralDb)'
            );
            
            // Apply status filter if selected
            const selectedStatus = this.multiSelectHedisForm.get('status')?.value;
            if (selectedStatus && selectedStatus.value) {
              filteredMembersList = filteredMembersList.filter(element => 
                element.status === selectedStatus.value
              );
              console.log('Total records after status filtering:', filteredMembersList.length);
            }
            
            // Apply measure filter if selected
            if (this.selectedMeasuresForHedis && this.selectedMeasuresForHedis.length > 0) {
              const selectedMeasureValues = this.selectedMeasuresForHedis.map((m: any) => m.value);
              filteredMembersList = filteredMembersList.filter(element => 
                selectedMeasureValues.includes(element.measure)
              );
              console.log('Total records after measure filtering:', filteredMembersList.length);
            }
            
            console.log('Total records after filtering:', filteredMembersList.length);

            if (filteredMembersList.length > 0) {
              this.downloadMultiSelectReport(filteredMembersList);
            } else {
              this.message = 'No Records Found';
              this.openModal('alertModal');
            }
            this.showSpinner = false;
            this.closeMultiSelectHedisDialog();
          },
          (error) => {
            console.error('Error generating report:', error);
            this.showSpinner = false;
            this.message = 'Error generating report: ' + (error.message || 'Unknown error');
            this.openModal('alertModal');
          }
        );
      }

      private loadQMDataForProviderStructured(providerId: any, provider: any): Observable<any> {
        // First, get the approved measure descriptions (same as old logic)
        return this.cupService.getMeasureDescriptionFromEdh(providerId).pipe(
          switchMap((measuresData: any) => {
            const diseasesList: any[] = [];
            const approvedMeasureIds = new Set<any>();
            
            // Build disease list from approved measures
            if (measuresData && measuresData.length > 0) {
              measuresData.forEach((disease: any) => {
                diseasesList.push({
                  measure: disease.measure,
                  measureId: disease.measureId,
                  dashboardDescription: disease.dashboardDescription
                });
                approvedMeasureIds.add(disease.measureId);
              });
            }
            
            // Then get member data
            const qmDataURL = this.urlConstant.qmMemberListView + providerId;
            return this.cupService.retrieveData('get', qmDataURL).pipe(
              map((data: any) => {
                const membersList: any = {};
                
                if (data && data.memberMeasures && data.memberMeasures.length > 0) {
                  data.memberMeasures.forEach((row: any) => {
                    // Only process measures that are in the approved disease list
                    if (!approvedMeasureIds.has(row.measureId)) {
                      return;
                    }
                    
                    // Skip 'Medication Adherence - Diabetes (OralDb)' measure
                    if (row.measure === 'Medication Adherence - Diabetes (OralDb)') {
                      return;
                    }
                    
                    const list: any[] = [];
                    
                    if (row.memberDetails && row.memberDetails.length > 0) {
                      row.memberDetails.forEach((member: any) => {
                        const obj: any = {};
                        obj.measure = row.measure;
                        obj.measureId = row.measureId;
                        obj.membername = member.firstName + ' ' + member.lastName;
                        obj.memberId = member.memberId;
                        obj.dob = member.dob;
                        obj.gender = member.gender;
                        obj.age = member.age;
                        obj.memberAddress = member.memberAddress;
                        obj.healthPlan = member.memberHealthPlan && member.memberHealthPlan.length > 0
                          ? member.memberHealthPlan[0]
                          : {};
                        obj.eventdate = member.memberQmDetails.length
                          ? this.dateService.convertDateFormat(member.memberQmDetails[0].eventDate)
                          : ' ';
                        obj.eventvalue = member.memberQmDetails.length
                          ? member.memberQmDetails[0].eventValue
                          : '';
                        obj.exclusionNote = member.memberQmDetails.length
                          ? member.memberQmDetails[0].excludedNote
                          : '';
                        obj.status = member.memberQmDetails.length
                          ? member.memberQmDetails[0].status
                          : '';
                        obj.statusDesc = member.memberQmDetails.length
                          ? member.memberQmDetails[0].statusDesc
                          : '';
                        obj.provider = provider;
                        list.push(obj);
                      });
                    }
                    
                    membersList[row.measureId] = {
                      eventValueExists: row.eventValueExists,
                      list: list,
                      measure: row.measure
                    };
                  });
                }
                
                return { membersList, diseasesList, provider };
              })
            );
          })
        );
      }

      private loadQMDataForProvider(providerUid: any, provider: any): Observable<any> {
        const qmDataURL = this.urlConstant.qmMemberListView + providerUid;
        return this.cupService.retrieveData('get', qmDataURL).pipe(
          map((data: any) => {
            const members: any[] = [];
            if (data && data.memberMeasures && data.memberMeasures.length > 0) {
              data.memberMeasures.forEach((row: any) => {
                if (row.memberDetails && row.memberDetails.length > 0) {
                  row.memberDetails.forEach((member: any) => {
                    const obj: any = {};
                    obj.measure = row.measure;
                    obj.measureId = row.measureId;
                    obj.membername = member.firstName + ' ' + member.lastName;
                    obj.memberId = member.memberId;
                    obj.dob = member.dob;
                    obj.gender = member.gender;
                    obj.age = member.age;
                    obj.memberAddress = member.memberAddress;
                    obj.healthPlan = member.memberHealthPlan && member.memberHealthPlan.length > 0
                      ? member.memberHealthPlan[0]
                      : {};
                    obj.eventdate = member.memberQmDetails.length
                      ? this.dateService.convertDateFormat(member.memberQmDetails[0].eventDate)
                      : ' ';
                    obj.eventvalue = member.memberQmDetails.length
                      ? member.memberQmDetails[0].eventValue
                      : '';
                    obj.provider = provider;
                    members.push(obj);
                  });
                }
              });
            }
            return { members };
          })
        );
      }

      private async downloadMultiSelectReport(membersData: any[]) {
        const formattedMembers = membersData.map(member => {
          let address1_Data: any = {};
          if (member.memberAddress && member.memberAddress.length > 0) {
            address1_Data = member.memberAddress[0];
          }
          
          const provider = member.provider || {};
          let pod = '';
          
          return [
            member.measure || '',
            member.memberId || '',
            member.membername || '',
            member.dob || '',
            member.gender || '',
            address1_Data.address1 || '',
            address1_Data.address2 || '',
            address1_Data.city || '',
            address1_Data.state || '',
            address1_Data.zip || '',
            address1_Data.phone || '',
            member.healthPlan?.memberPlanDesc || '',
            member.healthPlan?.memberPlanEffectiveDate 
              ? this.dateService.convertDateFormat(member.healthPlan.memberPlanEffectiveDate) 
              : '',
            pod,
            provider.name || '',
            provider.neighborhood || '',
            member.status || '',
            member.eventdate || '',
            member.eventvalue || '',
            '',
            '',
          ];
        });

        // Create Excel workbook using xlsx-js-style
        const reportTitle = "HEDIS Report";
        const headers = this.getCsvFileHeader();

        const headerStyle = {
          font:  { bold: true, color: { rgb: 'FFFFFF' } },
          fill:  { fgColor: { rgb: '23499E' }, patternType: 'solid' },
          border: {
            top:    { style: 'thin' },
            left:   { style: 'thin' },
            bottom: { style: 'thin' },
            right:  { style: 'thin' },
          },
          alignment: { vertical: 'center', wrapText: true },
        };

        const titleStyle = {
          font:      { bold: true, sz: 16 },
          alignment: { horizontal: 'center', vertical: 'center', wrapText: true },
        };

        const dataStyle = {
          alignment: { vertical: 'center', wrapText: true },
        };

        const titleRow  = [{ v: reportTitle, s: titleStyle }];
        const blankRow  = [''];
        const headerRow = headers.map((h: string) => ({ v: h, s: headerStyle }));
        const dataRows  = formattedMembers.map((row: any[]) =>
          row.map((cell: any) => ({ v: cell ?? '', s: dataStyle }))
        );

        const wsData = [titleRow, blankRow, headerRow, ...dataRows];
        const ws = XLSX.utils.aoa_to_sheet(wsData);

        // Column widths
        ws['!cols'] = [
          { wch: 30 }, // Measure
          { wch: 15 }, // Member ID
          { wch: 20 }, // Member Name
          { wch: 12 }, // DOB
          { wch: 10 }, // Gender
          { wch: 25 }, // Address1
          { wch: 25 }, // Address2
          { wch: 15 }, // City
          { wch: 10 }, // State
          { wch: 12 }, // Zip
          { wch: 15 }, // Phone
          { wch: 20 }, // Health Plan
          { wch: 15 }, // Effective Date
          { wch: 20 }, // POD
          { wch: 20 }, // PCP Name
          { wch: 15 }, // Region
          { wch: 12 }, // Status
          { wch: 15 }, // Event Date
          { wch: 15 }, // Event Value
          { wch: 12 }, // Lab Value
          { wch: 15 }, // Due By Date
        ];

        // Merge title row across all columns
        ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: headers.length - 1 } }];

        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, ws, 'HEDIS Report');

        const xlsxBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
        const blob = new Blob([xlsxBuffer], {
          type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        });
        const fileName = 'HEDIS_Report_' + new Date().getTime() + '.xlsx';
        saveAs(blob, fileName);
      }

      openModal(modalId: string) {
        const modal = new Modal(document.getElementById(modalId));
        modal.show();
    }
    
    closeModal(modalId: string) {
      const modalElement = document.getElementById(modalId);
        const  modal = Modal.getInstance(modalElement);
        if(modal!=null){
          modal.hide();
        }
    }
    onCloseSessionOut(modalId){
      const modalElement=document.getElementById(modalId);
      const modal=Modal.getInstance(modalElement);
      if(modal!=null){
        modal.hide();
        this.router.navigateByUrl('/logout');
    }
    
    }
}
